// extracted by mini-css-extract-plugin
export default {"Stars":"Stars_Stars__j74z+"};